import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Keeps the hidden `properties[_pre_order]` input in sync on a live variant switch.
 * The input is rendered from the variant selected at page load and is not a morph
 * target in product-form.js, so without this the form posts the wrong property:
 * missing when switching to a pre-order variant, stale when switching away from one.
 * Mirrors the pattern used by bbd-pre-order-note.js.
 */
class BbdPreOrderProperty extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#abortController.signal
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const { html, productId, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (productId && this.dataset.productId && productId !== this.dataset.productId) {
          return;
        }

        const newProperty = html.querySelector(`bbd-pre-order-property[data-form-id="${this.dataset.formId}"]`);
        if (!newProperty) return;

        morph(this, newProperty, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError')
          console.warn('[bbd-pre-order-property] Product select promise rejected:', error);
      });
  };
}

if (!customElements.get('bbd-pre-order-property')) {
  customElements.define('bbd-pre-order-property', BbdPreOrderProperty);
}
